import 'uni-pages';wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import App from './App'


import Vue from 'vue'
// Vue.prototype.baseUrl = "http://localhost:8081/acs"
Vue.prototype.baseUrl = "http://localhost:8082/xgmwms"
Vue.config.productionTip = false
App.mpType = 'app'
const app = new Vue({
    ...App
})
app.$mount()